import { PopoverPlacement } from "@idui/react-popover";
import { InfoOutlined } from "@mui/icons-material";
import { Checkbox, FormControlLabel } from "@mui/material";
import { FC } from "react";

import { useIsMobile } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import { REBUILD_ROUTE_DROPDOWN_INFO_TOOLTIP_MOUSE_ENTER_DELAY_MS } from "./rebuild-route-dropdown.constants";

interface IRebuildRouteDropdownSkipCacheRowProps {
  checked: boolean;
  label: string;
  tooltip: string;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const RebuildRouteDropdownSkipCacheRow: FC<
  IRebuildRouteDropdownSkipCacheRowProps
> = ({ checked, label, tooltip, disabled = false, onChange }) => {
  const { isMobile } = useIsMobile();

  return (
    <div className="rebuild-route-dropdown-skip-cache-row">
      <FormControlLabel
        className="rebuild-route-dropdown-option-item rebuild-route-dropdown-default-action-checkbox"
        disabled={disabled}
        control={
          <Checkbox
            size="small"
            checked={checked}
            disabled={disabled}
            onChange={event => onChange(event.target.checked)}
          />
        }
        label={label}
      />

      {!isMobile && (
        <FramerTooltip
          content={tooltip}
          placement={PopoverPlacement.top}
          mouseEnterDelay={
            REBUILD_ROUTE_DROPDOWN_INFO_TOOLTIP_MOUSE_ENTER_DELAY_MS
          }
        >
          <button
            type="button"
            className="rebuild-route-dropdown-skip-cache-info"
            aria-label={tooltip}
          >
            <InfoOutlined fontSize="inherit" />
          </button>
        </FramerTooltip>
      )}
    </div>
  );
};
